import globalSlice from "./slices/globalSlice";
import userSlice from "./slices/userSlice";
import roleSlice from "./slices/roleSlice";
import permissionSlice from "./slices/permissionSlice";
import vendorSlice from "./slices/vendorSlice";
import dashboardSlice from "./slices/dashboardSlice";
import challengeSlice from "./slices/ChallangesSlice";
import questionSlice from "./slices/QuestionSlice";
import emailTemplateSlice from "./slices/EmailTemplateSlice";
import freeFormSlice from "./slices/FreeFormSlice";
import invitationSlice from "./slices/invitationSlice";
import organizationSlice from "./slices/organizationSlice";
import activityLogSlice from "./slices/activityLogSlice";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  global: globalSlice,
  user: userSlice,
  role: roleSlice,
  permission: permissionSlice,
  // category: categorySlice,
  // subCategory: subCategorySlice,
  // product: productSlice,
  vendor: vendorSlice,
  // offer: offerSlice,
  dashboard: dashboardSlice,
  // campaign: campaignSlice,
  // order: orderSlice
  challanges: challengeSlice,
  questions:questionSlice,
  emailTemplate : emailTemplateSlice,
  freeForm : freeFormSlice,
  invitation: invitationSlice,
  organization: organizationSlice,
  activityLog: activityLogSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
